export default __webpack_public_path__ + "static/media/bg1-section-mobile.b3cd78f9.png";